{
  "version": "1.2.6",
  "objects": {
    "7536295120977301221": {
      "type": "frame",
      "id": "7536295120977301221",
      "z": 11697,
      "textContent": "",
      "left": 4222.776829201749,
      "top": 1209.0960202092733,
      "width": 1110,
      "height": 625,
      "scaleX": 0.2306793579279828,
      "scaleY": 0.37334877975239433,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a383n",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 20,
      "layoutPadding": 20,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295120981398518": {
      "type": "frame",
      "id": "7536295120981398518",
      "z": 22,
      "textContent": "",
      "left": 4242.776829201749,
      "top": 1229.0960202092733,
      "width": 1110,
      "height": 625,
      "scaleX": 0.19464332189194677,
      "scaleY": 0.1328,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7536295120977301221",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a18KT",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 2,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7536295120980741856": {
      "type": "shape",
      "id": "7536295120980741856",
      "z": 23,
      "shapeName": "text",
      "textContent": "<p><strong>$9,100.39</strong></p>",
      "left": 4242.776829201749,
      "top": 1261.0960202092733,
      "width": 72.33333333333334,
      "height": 29.75,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.7142857142857142,
      "scaleY": 1.7142857142857142,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 24,
      "angle": 0,
      "container": "7536295120981398518",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a08wm",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7536295120971562711": {
      "type": "shape",
      "id": "7536295120971562711",
      "z": 24,
      "shapeName": "text",
      "textContent": "<p>Monthly sales</p>",
      "left": 4242.776829201749,
      "top": 1229.0960202092733,
      "width": 96,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 14,
      "angle": 0,
      "container": "7536295120981398518",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "ZzkBL",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7536295120985298977": {
      "type": "frame",
      "id": "7536295120985298977",
      "z": 70,
      "textContent": "",
      "left": 4242.776829201749,
      "top": 1332.0960202092733,
      "width": 1110,
      "height": 625,
      "scaleX": 0.19464332189194677,
      "scaleY": 0.14454877975239433,
      "fill": "#FCA841",
      "opacity": 0.2,
      "container": "7536295120977301221",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a26LV",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 2,
      "layoutPadding": 50,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7536295120976683687": {
      "type": "wireframe",
      "id": "7536295120976683687",
      "z": 71,
      "top": 1346.34109787215,
      "left": 4319.70097585889,
      "width": 472.06155962624246,
      "height": 236.57315499890086,
      "scaleX": 0.13177474996064362,
      "scaleY": 0.2572262775113937,
      "container": "7536295120985298977",
      "layoutPosition": "a0Bow",
      "wireframeName": "barChart",
      "fill": "#FCA841",
      "textColor": "#333333",
      "style": "donutChart",
      "fontSize": 14,
      "label": {},
      "placeholder": {},
      "setDimension": true
    }
  }
}
